import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { useSettings } from "@/hooks/queries";
import { brandParts } from "@/lib/format";

const LINKS = [
  { to: "/#trip", label: "Trip", id: "trip" },
  { to: "/jadwal", label: "Jadwal", id: "jadwal" },
  { to: "/cek-pesanan", label: "Cek Pesanan", id: "cek-pesanan" },
];

export const Brand = () => {
  const { data } = useSettings();
  const { prefix, main } = brandParts(data?.business_name || "Private Trip Siput Gunung");
  return (
    <Link to="/" data-testid="nav-brand-logo" className="group flex flex-col leading-none">
      {prefix && <span className="text-[9px] font-semibold uppercase tracking-[0.4em] text-gold">{prefix}</span>}
      <span className="mt-1 font-display text-xl italic tracking-tight text-white sm:text-2xl">{main}</span>
    </Link>
  );
};

const linkCls = ({ isActive }) =>
  `text-sm transition-colors hover:text-white ${isActive ? "text-white" : "text-neutral-400"}`;

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 border-b transition-[background-color,border-color] duration-300 ${
        scrolled ? "border-white/10 bg-black/70 backdrop-blur-xl" : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 sm:h-20 sm:px-8">
        <Brand />
        <nav className="hidden items-center gap-9 md:flex">
          {LINKS.map((l) => (
            <NavLink key={l.id} to={l.to} className={linkCls} data-testid={`nav-link-${l.id}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <Link to="/#trip" className="btn-gold hidden h-11 md:inline-flex" data-testid="nav-btn-book-now">
          Pesan Trip
        </Link>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 md:hidden" data-testid="nav-mobile-menu-btn">
              <Menu className="h-5 w-5" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="border-white/10 bg-ink-950">
            <SheetTitle className="sr-only">Menu</SheetTitle>
            <nav className="mt-12 flex flex-col gap-6">
              {LINKS.map((l) => (
                <Link key={l.id} to={l.to} onClick={() => setOpen(false)} className="font-display text-3xl" data-testid={`mobile-nav-link-${l.id}`}>
                  {l.label}
                </Link>
              ))}
              <Link to="/#trip" onClick={() => setOpen(false)} className="btn-gold mt-4" data-testid="mobile-nav-btn-book-now">
                Pesan Trip
              </Link>
            </nav>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};
